// Encryption constants for AliveGuardian

// AES-GCM configuration for document encryption
export const AES_ALGORITHM = 'AES-GCM';
export const AES_KEY_LENGTH = 256; // bits
export const AES_IV_LENGTH = 12; // bytes (96 bits, recommended for GCM)
export const AES_TAG_LENGTH = 128; // bits

// RSA-OAEP configuration for key wrapping
export const RSA_ALGORITHM = 'RSA-OAEP';
export const RSA_MODULUS_LENGTH = 4096; // bits
export const RSA_PUBLIC_EXPONENT = new Uint8Array([1, 0, 1]); // 65537
export const RSA_HASH = 'SHA-256';

// Key usages
export const AES_KEY_USAGES: KeyUsage[] = ['encrypt', 'decrypt'];
export const RSA_PUBLIC_KEY_USAGES: KeyUsage[] = ['wrapKey'];
export const RSA_PRIVATE_KEY_USAGES: KeyUsage[] = ['unwrapKey'];
